import React, { useState, Component, useEffect, useRef } from 'react';
import '../../src/Hero2.css';
import { Loader } from 'semantic-ui-react';
import { Mensaje } from './mensajes';
import 'animate.css';
import Fade from 'react-reveal/Fade';
import Reveal from 'react-reveal/Reveal';
import Slide from 'react-reveal/Slide';
import Roll from 'react-reveal/Roll';
import Jello from 'react-reveal/Jello';
import makeCarousel from 'react-reveal/makeCarousel';
import styled, { css } from 'styled-components';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { Dimmer } from 'semantic-ui-react';
import Feedback from 'react-bootstrap/Feedback';
import '../../src/Hero2.css';






function QuienesSomos() {



    const [mostrar, setMostrar] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({
        txtNombre: '',
        txtEmail: ''
    });
    const slider = useRef()



    const abrirModal = () => {
        setMostrar(true);
    }

    const cerrarModal = () => {
        setMostrar(false);
    }

    const enviarCorreo = () => {

        setActivate(true);



        let endpoint = "http://3.141.30.169:5000/send-email";

        axios.post(endpoint, {

            email: 'tvalentin@gmail.com',
            name: values.txtEmail,
            passwd: '',
            message: values.txtNombre

        }).then(function (response) {

            if (response.status == 200) {

                setTitulo("enviado con exito!");
                setMsg('pronto recibirar respuestas');
                setMostrar1(true);

            } else if (response.status == 204) {
                setTitulo("notificación");
                setMsg("correo no encontrado");
                setMostrar1(true);


            }


        }).catch(function (error) {
            setTitulo("notificación");
            setMsg("Error interno de Conexión.");
            setMostrar1(true);

        }).then(function () {
            setActivate(false);
        });

    }

    const onChange = (event) => {

        setValues({ ...values, [event.target.name]: event.target.value });

    };


    const handleCloseMensa = () => {

        setMostrar1(false);

    }

    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            enviarCorreo();
        }

        setValidated(true);
    };

    console.log(values)

    return (


        <div className='col-md-12 container-fluid' style={{ padding: 0, margin: 0 }}>
            <div className='contenedor-ubicanos'>
                <img className='img-fluid' src='imagenes/compu1.jpg' style={{ width: '100%', height: '100%' }} />
                <div className='hover-ubicanos'></div>
              
                    <div className='contenet-ubicanos contenedor-fluid'>

                        <h3>Quienes Somos </h3>

                    </div>
               
            </div>
        </div>





    )

} export default QuienesSomos;



// WEBPACK FOOTER //
// ./src/components/quienes.js